export default "__VITE_ASSET__D4NK3Os___"